module.exports = __webpack_public_path__ + "static/media/printer@3x.ff8d7f54.png";